import C from "../../common/constantes"
import Sales from '../../../services/sales'
import messageDialog from '../../../components/message-dialog.vue';
import {EventBus} from '../../../event-bus'

export default {
  props: ['type', 'rodosol'],
  data() {
    return {
      loading: undefined,
    }
  },


  computed:{
    sameTax(){
      return this.newAhesionTaxMan == this.newVehicleTaxMan && this.newAhesionTaxAut == this.newVehicleTaxAut
    },
    newAhesionTaxCont(){
      return this.$store.getters.getNewAdhesionTax(C.PLAN_MAN);
    },
    newVehicleTaxCont(){
      return this.$store.getters.getNewVehicleTax(C.PLAN_MAN);
    },
    newAhesionTaxConf(){
      return this.$store.getters.getNewAdhesionTax(C.PLAN_AUT);
    },
    newVehicleTaxConf(){
      return this.$store.getters.getNewVehicleTax(C.PLAN_AUT);
    },
    newAhesionTaxSemC(){
      return 0;
      //return this.$store.getters.getNewAdhesionTax(C.PLAN_MOVE_PAGUE);
    },
    newVehicleTaxSemC(){
      return 0;
      //return this.$store.getters.getNewVehicleTax(C.PLAN_MOVE_PAGUE);
    },
    guaranteeTaxSemC(){
      return 0;
      //return this.$store.getters.getGuaranteeTax(C.PLAN_MOVE_PAGUE);
    },
    newAhesionTaxPreMen(){
      return this.$store.getters.getNewAdhesionTax(C.PLAN_PREMEN_PF);
    },
    newVehicleTaxPreMen(){
      return this.$store.getters.getNewVehicleTax(C.PLAN_PREMEN_PF);
    },
    checkPromoSenff() {
      if (sessionStorage.getItem('promoCheck') == '#SENFF2020')
        return true;
    },
},

  methods:{
    choose(planId){
      if(this.type=='newContract') {
        EventBus.$emit('chooseNewPlan', planId);
      } else if(this.type=='migration') {
        EventBus.$emit('migrationPlan', planId);
      } else {
        this.$router.push({'name': 'adhesion', 'query':{'planId': planId}});
      }
    },

  }
}



// WEBPACK FOOTER //
// ./src/pages/external/plans/b2c.js